import React, { useState } from 'react';
import styled from 'styled-components';
import { colors } from '../../../stylesheets';
import {
  getToggleBackgroundColor,
  getToggleBorderColor,
  getTogglerBackgroundColor,
} from '../../../utils/getToggleColor';

type Props = {
  disabled?: boolean,
  className?: string,
  onChange: Function,
  active?: boolean,
};

const StyledToggle = styled.div`
  width: 40px;
  height: 20px;
  display: flex;
  border: 1px ${(props) => colors[getToggleBorderColor(props.isActive)]} solid;
  border-radius: 10px;
  position: relative;
  background: ${(props) =>
    colors[getToggleBackgroundColor(props.isActive, props.isDisabled)]};
`;

const StyledToggler = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 8px;
  position: absolute;
  top: 1px;
  background: ${(props) =>
    colors[getTogglerBackgroundColor(props.isActive, props.isDisabled)]};
  left: ${(props) => (props.isActive ? 2 : 20)}px;
  transition: all 0.2s ease;
`;

const Toggle = ({ disabled, onChange, className, active }: Props) => {
  const [isActiveToggle, setIsActiveToggle] = useState(active);

  const handleClick = () => {
    if (!disabled) {
      setIsActiveToggle(!isActiveToggle);
    }
    onChange(!active);
  };

  return (
    <StyledToggle
      onClick={handleClick}
      isActive={isActiveToggle}
      isDisabled={disabled}
      className={className}
    >
      <StyledToggler isActive={isActiveToggle} isDisabled={disabled} />
    </StyledToggle>
  );
};

Toggle.defaultProps = {
  disabled: false,
  className: '',
  active: false,
};

export default Toggle;
